module.exports = __webpack_public_path__ + "static/media/200x200.0992a405.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/utils/200x200.jpg
// module id = 56
// module chunks = 0